'use strict';

var _ = require('lodash');
var SerializeStrategyService = function SerializeStrategyService(actionSerializer, conditionSerializer, strategyClosureActionService, strategyAllocationAuthAvailActionService, strategyConstants) {
  function parseStrategy(strategy) {
    if (strategy["public"] === undefined) {
      strategy["public"] = !strategy.isRestricted;
    }
    parseClassClosureGroups(strategy, strategy.basis === strategyConstants.StrategyType.CLASS_CLOSURE);
    parseAllocationAuthAvailGroups(strategy, strategy.basis === strategyConstants.StrategyType.ALLOCATION_AUTH_AVAIL);
    parseCustomGroups(strategy, !strategy.basis || strategy.basis === strategyConstants.StrategyType.CUSTOM);
    return strategy;
  }
  function parseClassClosureGroups(strategy, isClassClosureStrategy) {
    if (!isClassClosureStrategy) {
      return;
    }
    strategy.level = strategyConstants.CLASS_CLOSURE.LEVEL;
    if (_.isString(strategy.commonConditions)) {
      strategy.commonConditions = conditionSerializer.deserialize(strategy.level, strategy.type, strategy.flowType, strategy.commonConditions);
    }
    var conditionGroups = [];
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        conditionGroups.push(conditionSerializer.parse(statement.conditions));
      });
      delete strategy.statements;
    }
    if (!strategy.actionList) {
      strategy.actionList = strategyClosureActionService.getActionList(conditionGroups);
      strategyClosureActionService.adjustLoadFactorValues(strategy.actionList);
    }
  }
  function parseAllocationAuthAvailGroups(strategy, isAllocationAuthAvailStrategy) {
    if (!isAllocationAuthAvailStrategy) {
      return;
    }
    strategy.level = strategyConstants.ALLOCATION_AUTH_AVAIL.LEVEL;
    if (_.isString(strategy.commonConditions)) {
      strategy.commonConditions = conditionSerializer.deserialize(strategy.level, strategy.type, strategy.flowType, strategy.commonConditions);
    }
    var conditionGroups = [];
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        conditionGroups.push({
          conditions: conditionSerializer.parse(statement.conditions),
          actions: createActionMap(statement.actions)
        });
      });
      delete strategy.statements;
    }
    if (!strategy.actionList) {
      strategy.actionList = strategyAllocationAuthAvailActionService.getActionList(conditionGroups);
    }
  }
  function parseCustomGroups(strategy, isCustomStrategy) {
    if (!isCustomStrategy) {
      return;
    }
    if (strategy.statements) {
      strategy.groups = [];
      strategy.statements.forEach(function (statement) {
        var group = {};
        group.level = statement.level;
        if (statement.conditions) {
          group.conditions = conditionSerializer.deserialize(statement.level, strategy.type, strategy.flowType, statement.conditions);
        } else {
          group.conditions = [];
        }
        group.actions = actionSerializer.deserialize(statement, strategy.type);
        strategy.groups.push(group);
      });
      delete strategy.statements;
    }
  }
  function createActionMap(actionLst) {
    var actionMap = {};
    actionLst.forEach(function (action) {
      actionMap[action.split(' ')[1]] = _.isNil(action.split('\'')[1]) ? _.toInteger(action.split(' ')[3]) : action.split('\'')[1];
    });
    return actionMap;
  }
  return {
    parseStrategy: parseStrategy
  };
};
SerializeStrategyService.$inject = ['ActionSerializerService', 'ConditionSerializerService', 'StrategyClosureActionService', 'StrategyAllocationAuthAvailActionService', 'StrategyConstants'];
module.exports = SerializeStrategyService;